import Alpine from 'alpinejs';
import IMask from 'imask';

Alpine.store('formValid', {

    form: {
        email: '',
        placeholderText: 'Email',
    },
    contactForm: {
        email: '',
        name: '',
        phone: '',
        message: '',
        form: ''
    },
    contactForm1: {
        email: '',
        name: '',
        phone: '',
        message: '',
        form: ''
    },

    errors: {
        email: null,
    },

    contactErrors: {
        email: null,
        name: null,
        phone: null,
    },
    contactErrors1: {
        email: null,
        name: null,
        phone: null,
    },


    validateForm() {
        const emailPattern = /^[^\s@()]+@[^\s@]+\.[^\s@]+$/;


        this.errors = {
            email: !this.form.email ? 'Заповніть це поле' :
                !emailPattern.test(this.form.email) ? 'Введіть коректний email' : null,
        };

        if (!Object.values(this.errors).some(error => error)) {
            this.sendFormEmail();
        }
    },


    sendFormEmail() {
        const formData = {
            email: this.form.email,
        };

        fetch('/api/v1/store/email_subscription', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(async response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                this.clearForm();
                this.form.placeholderText = 'Дякуємо';
                setTimeout(() => {
                    this.form.placeholderText = 'Email';
                }, 3000);
            })
            .catch(error => {
                console.error(error);
            });
    },


    clearForm(fieldName = null) {
        if (fieldName) {
            this.form[fieldName] = '';
            this.errors[fieldName] = null;
        } else {
            this.form.email = '';
            this.errors.email = null;
        }
    },


    validateContactForm() {
        const emailPattern = /^[^\s@()]+@[^\s@]+\.[^\s@]+$/;
        const namePattern = /^[A-Za-zА-Яа-яЁёЇїІіЄєҐґ']+$/;
        const phonePattern = /^\+38\(\d{3}\)\d{3}-\d{2}-\d{2}$/;

        this.contactErrors = {
            name: !this.contactForm.name ? 'Заповніть це поле' :
                this.contactForm.name.length < 2 ? 'Ім’я повинно містити хоча б 2 символи' :
                    !namePattern.test(this.contactForm.name) ? 'Ім’я повинно містити тільки літери' : null,
            phone: !this.contactForm.phone ? 'Заповніть це поле' :
                !phonePattern.test(this.contactForm.phone) ? 'Введіть коректний номер телефону' : null,
            email: !this.contactForm.email ? 'Заповніть це поле' :
                !emailPattern.test(this.contactForm.email) ? 'Введіть коректний email' : null,
        };

        if (!Object.values(this.contactErrors).some(error => error)) {
            this.sendFormContact();
        }
    },
    validateContactForm1() {
        const emailPattern = /^[^\s@()]+@[^\s@]+\.[^\s@]+$/;
        const namePattern = /^[A-Za-zА-Яа-яЁёЇїІіЄєҐґ']+$/;
        const phonePattern = /^\+38\(\d{3}\)\d{3}-\d{2}-\d{2}$/;

        this.contactErrors1 = {
            name: !this.contactForm1.name ? 'Заповніть це поле' :
                this.contactForm1.name.length < 2 ? 'Ім’я повинно містити хоча б 2 символи' :
                    !namePattern.test(this.contactForm1.name) ? 'Ім’я повинно містити тільки літери' : null,
            phone: !this.contactForm1.phone ? 'Заповніть це поле' :
                !phonePattern.test(this.contactForm1.phone) ? 'Введіть коректний номер телефону' : null,
            email: !this.contactForm1.email ? 'Заповніть це поле' :
                !emailPattern.test(this.contactForm1.email) ? 'Введіть коректний email' : null,
        };

        if (!Object.values(this.contactErrors1).some(error => error)) {
            this.sendFormContact1();
        }
    },


    sendFormContact() {
        const formData = {
            email: this.contactForm.email,
            name: this.contactForm.name,
            phone: this.contactForm.phone,
            message: this.contactForm.message,
            form: document.querySelector('.activeText1').value,
        };

        fetch('/api/v1/store/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(async response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                this.clearFormContact();
            })
            .catch(error => {
                console.error(error);
            });
    },
    sendFormContact1() {
        const formData = {
            email: this.contactForm1.email,
            name: this.contactForm1.name,
            phone: this.contactForm1.phone,
            message: this.contactForm1.message,
            form: document.querySelector('.activeText11').value,
        };

        fetch('/api/v1/store/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(async response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                this.clearFormContact1();
            })
            .catch(error => {
                console.error(error);
            });
    },


    clearFormContact(fieldName = null) {
        const newFormFields = ['name', 'email', 'phone', 'message'];
        newFormFields.forEach(fieldName => {
            this.contactForm[fieldName] = '';
            const inputField = document.querySelector(`input[name="${fieldName}"]`);
            if (inputField) {
                inputField.value = '';
            }
        });
    },
    clearFormContact1(fieldName = null) {
        const newFormFields = ['name', 'email', 'phone', 'message'];
        newFormFields.forEach(fieldName => {
            this.contactForm1[fieldName] = '';
            const inputField = document.querySelector(`input[name="${fieldName}"]`);
            if (inputField) {
                inputField.value = '';
            }
        });
    },

});

document.addEventListener('DOMContentLoaded', () => {

        const phoneInputs = document.querySelectorAll('input[name="phone"]');
        phoneInputs.forEach(input => {
            IMask(input, {
                mask: '+{38}(000)000-00-00'
            });
        });


    const nameInput = document.querySelector('input[name="name"]');
    if (nameInput) {
        nameInput.addEventListener('keypress', (e) => {
            if (/\d/.test(e.key)) {
                e.preventDefault();
            }
        });

        nameInput.addEventListener('paste', (e) => {
            e.preventDefault();
            const pastedText = (e.clipboardData || window.clipboardData).getData('text');
            const filteredText = pastedText.replace(/\d/g, '');
            document.execCommand('insertText', false, filteredText);
        });
    }


    const messageInput = document.querySelector('textarea[name="message"]');
    if (messageInput) {
        messageInput.addEventListener('keypress', (e) => {
            if (['<', '>', '&', '#', '$'].includes(e.key)) {
                e.preventDefault();
            }
        });

        messageInput.addEventListener('paste', (e) => {
            e.preventDefault();
            const pastedText = (e.clipboardData || window.clipboardData).getData('text');
            const filteredText = pastedText.replace(/[<>&#]/g, '');
            document.execCommand('insertText', false, filteredText);
        });
    }
});
